import React from "react";
import "../style/oferta.css"; // Upewnij się, że ta ścieżka się zgadza

const Oferta = () => {
  return (
    <div className="oferta-grid">
  {[
    "Nadzór informatyczny na najwyższym poziomie",
    "Instalacja i konfiguracja sieci strukturalnych (LAN)",
    "Budowa i administracja systemów serwerowych",
    "Konfiguracja połączeń internetowych",
    "Rozwiązywanie problemów sprzętowych i programowych",
    "Doradztwo w zakupie, modernizacji i serwisie sprzętu",
    "Instalacja i kontrola oprogramowania antywirusowego",
    "Wdrażanie i nadzór nad systemami kopii zapasowych",
    "Obsługa programów firmy REKORD SI Sp. z o.o.",
    "Obsługa programu COMARCH OPTIMA",
    "Obsługa programu Mmedica firmy Asseco",
    "Obsługa programu PŁATNIK ZUS",
    "Obsługa programów dla GOPS (TOP-TEAM, INFOR Skoczów)"
  ].map((item, index) => (
    <div key={index} className="oferta-card">
      <span className="checkmark">✓</span>
      {item}
    </div>
  ))}
</div>
  );
};

export default Oferta;
